import styled, { css } from 'styled-components';
import { display3Style, titleLStyle, paragraphLStyle } from 'components/Gen.2/Typography';
import { sizes } from 'style';
import { th, variants } from 'style/theme';

export const Coverage = styled.div`
  display: grid;
  gap: 32px;

  @media ${sizes.tabletPortrait} {
    gap: 48px;
  }
`;

export const Heading = styled.h2`
  ${titleLStyle}
  max-width: 800px;
  @media ${sizes.tabletPortrait} {
    ${display3Style}
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    min-height: 466px;
  }
`;

export const SelectContainer = styled.div`
  width: 100%;

  @media ${sizes.tabletPortrait} {
    max-width: 480px;
  }
`;

export const CoverageBox = styled.div<{ variant?: 'light' | 'dark' }>`
  width: 100%;
  max-width: 650px;
  padding: 18px 12px;
  margin-top: 20px;
  border-radius: 32px;
  box-shadow: ${th('shadows.small')};

  ${variants('variant', {
    light: css`
      background-color: ${th('colors.pink')};
    `,
    dark: css`
      background-color: ${th('colors.minsk')};
    `
  })};

  @media ${sizes.tabletPortrait} {
    width: 80%;
    margin-top: 0;
    margin-left: 32px;
  }

  @media ${sizes.desktop} {
    width: 100%;
    padding: 34px 40px;
  }

  @media ${sizes.largeDesktop} {
    max-width: 700px;
  }
`;

export const Placeholder = styled.h4`
  margin-bottom: 0;
  ${paragraphLStyle};

  @media ${sizes.desktop} {
    ${titleLStyle};
  }
`;
